import VueTypes, { nullable } from 'vue-types';

const imagePositions = ['right', 'left'];
export const themes = ['default', 'dark']
export const defaultTheme = themes[0]

export const TitleSettings = VueTypes.shape({
    title: VueTypes.string.isRequired,
    title_background_color: VueTypes.oneOfType([String, nullable]).def(null),
    title_text_color: VueTypes.oneOfType([String, nullable]).def(null)
}).isRequired;

export const InfoBlock = VueTypes.shape({
    id: VueTypes.number.isRequired,
    image: VueTypes.string.isRequired,
    content: VueTypes.string.isRequired,
    image_position: VueTypes.oneOf(imagePositions).def(imagePositions[0])
}).isRequired;

export const IconCardBlock = VueTypes.shape({
    id: VueTypes.number.isRequired,
    icons_card_items: VueTypes.arrayOf({
        id: VueTypes.number.isRequired,
        text: VueTypes.string.isRequired,
        icon: VueTypes.string.isRequired,
        background_color: VueTypes.oneOfType([String, nullable]).def(null),
        text_color: VueTypes.oneOfType([String, nullable]).def(null)
    }).isRequired
}).isRequired;

export const NumericBlock = VueTypes.shape({
    id: VueTypes.number.isRequired,

    numeric_block_items: VueTypes.arrayOf({
        id: VueTypes.number.isRequired,
        order: VueTypes.number.isRequired,
        text: VueTypes.string.isRequired,
        text_color: VueTypes.oneOfType([String, nullable]).def(null)
    }).isRequired
}).isRequired;

export const CustomContentBlock = VueTypes.shape({
    id: VueTypes.number.isRequired,
    content: VueTypes.string.isRequired,
}).isRequired;

// MOCKS

// TitleSettings
// {
//     title: 'Content image block',
//     title_background_color: null,
//     title_text_color: null,
// }

// InfoBlock
// {
//     id: 1,
//     image_position: 'right',
//     image: 'https://admin.ecom.md/media/carousels/ccc8bc1bf397b498c31e332d289709fb_AfjJGf4.png',
//     content: `
//         <h3>Eleganță și funcționalitate în interiorul casei tale</h3>
//         Ușile exterioare personalizate sunt concepute pentru a îndeplini aceste cerințe și pentru a vă oferi un nivel înalt de flexibilitate și control în ceea ce privește aspectul și performanța lor.
//         Fie că alegeți o intrare mare și impunătoare sau o intrare mai intimă și prietenoasă, ușile exterioare personalizate pot fi proiectate și adaptate pentru a reflecta stilul și personalitatea unice ale casei dvs. <br>
//         Având în vedere diversele condiții meteorologice și factori de mediu la care sunt supuse, ușile exterioare personalizate sunt construite pentru a rezista la uzură și a oferi protecție împotriva elementelor naturale. Alegerea materialelor potrivite și aplicarea finisajelor de calitate asigură durabilitatea și aspectul estetic pe termen lung al ușilor dvs. exterioare.
//         <br>
//         Ușile exterioare personalizate sunt un aspect esențial al aspectului și funcționalității casei dvs. Oferind o primă impresie asupra locuinței dvs.,acestea trebuie să fie nu doar estetice, ci și robuste și sigure.
//     `,
// }

// IconCardBlock
// {
//     id: 2,
//     icons_card_items: [
//         {
//             id: 1,
//             text: 'My text some',
//             icon: 'https://admin.ecom.md/media/settings_images/wrap.png',
//             background_color: null,
//             text_color: null,
//         },
//         {
//             id: 2,
//             text: 'My text some',
//             icon: 'https://admin.ecom.md/media/settings_images/wrap.png',
//             background_color: null,
//             text_color: null,
//         },
//         {
//             id: 3,
//             text: 'My text some',
//             icon: 'https://admin.ecom.md/media/settings_images/wrap.png',
//             background_color: null,
//             text_color: null,
//         },
//         {
//             id: 4,
//             text: 'My text some',
//             icon: 'https://admin.ecom.md/media/settings_images/wrap.png',
//             background_color: null,
//             text_color: null,
//         },
//         {
//             id: 5,
//             text: 'My text some',
//             icon: 'https://admin.ecom.md/media/settings_images/wrap.png',
//             background_color: null,
//             text_color: null,
//         },
//     ]
// }

// NumericBlock
// {
//     id: 3,
//     numeric_block_items: [
//         {
//             id: 1,
//             text: 'Începem prin discutarea preferințelor și necesităților dvs., stabilind împreună direcția și specificațiile proiectului.',
//             text_color: null,
//         },
//         {
//             id: 2,
//             text: 'Începem prin discutarea preferințelor și necesităților dvs., stabilind împreună direcția și specificațiile proiectului.',
//             text_color: null,
//         },
//         {
//             id: 3,
//             text: 'Începem prin discutarea preferințelor și necesităților dvs., stabilind împreună direcția și specificațiile proiectului.',
//             text_color: null,
//         },
//         {
//             id: 4,
//             text: 'Începem prin discutarea preferințelor și necesităților dvs., stabilind împreună direcția și specificațiile proiectului.',
//             text_color: null,
//         },
//         {
//             id: 5,
//             text: 'Începem prin discutarea preferințelor și necesităților dvs., stabilind împreună direcția și specificațiile proiectului.',
//             text_color: null,
//         },
//         {
//             id: 6,
//             text: 'Începem prin discutarea preferințelor și necesităților dvs., stabilind împreună direcția și specificațiile proiectului.',
//             text_color: null,
//         },
//     ]
// }

// CustomContentBlock
// {
//     id: 1,
//     content: `
//         <ul>
//             <li>
//             My text over here
//             </li>
//         </ul>
//     `
// }